import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { updateMyReservation } from '../redux/slices/myselfSlice';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

const UserCancelReservationModal = ({
  setCancelModal,
  selectedReservation,
  setSelectedReservation,
  onReservationUpdated,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.myself.loading);
  const { t } = useTranslation();

  const cancelReservation = async () => {
    if (selectedReservation) {
      try {
        setCancelModal(false);

        await dispatch(
          updateMyReservation({
            ...selectedReservation,
            reservationStatus: 'canceled',
          })
        ).unwrap();

        setSelectedReservation(null);
        // Refresh reservations after successful cancel
        if (onReservationUpdated) {
          onReservationUpdated();
        }
      } catch (error) {
        toast.error(i18n.t('reservations.cancelError'));
      }
    } else {
      toast.error(i18n.t('reservations.noReservationSelected'));
    }
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-8 rounded-md shadow-lg w-1/2 max-w-lg">
        <form>
          <label className="block mb-2 text-lg font-bold">
            {t('reservations.cancelModal.title')}{' '}
            <span className="text-red-500"> {t('reservations.cancelModal.cancelWord')} </span>{' '}
            {t('reservations.cancelModal.yourReservation')}
          </label>
          <div className="flex justify-end">
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-md"
              type="button"
              onClick={() => cancelReservation()}
              disabled={loading}
            >
              {loading
                ? t('reservations.cancelModal.canceling')
                : t('reservations.cancelModal.confirm')}
            </button>
            <button
              className="ml-4 bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-md"
              onClick={() => setCancelModal(false)}
              type="button"
              disabled={loading}
            >
              {t('reservations.cancel')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export { UserCancelReservationModal };
